import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import FileCopyIcon from '@material-ui/icons/FileCopy';
import RequestAccessToken from "../util/authService";
import CircularProgress from '@material-ui/core/CircularProgress';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const MessageAttachment = (props: any) => {
    let { documentFileName, documentId, apiHost } = props;
    const history = useHistory();
    let [tokenState, setTokenState] = useState(null);
    let [downloadingState, setDownloadState] = useState(false);
    let [downloadErrorState, setDownloadErrorState] = useState(false);
    let [errorMessage, setErrorMessage] = useState('');

    let tokenStatePr = RequestAccessToken().then((token) => {
        if (token && !tokenState) {
            setTokenState(token);
        }
    });


    const downloadDocument = (documentId: string, documentName: string, accessToken: string, document: any) => {
        setDownloadState(true);
        setDownloadErrorState(false);

        let request = {
            DocumentId: documentId,
            Name: documentName
        }

        const options = {
            method: "POST",
            headers: {
                Accept: "application/json",
                'Content-Type': 'application/json;',
                Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(request)
        };

        fetch(`https://${apiHost}/api/AzureStorage/GetBlob/`, options)
            .then((res) => { return res.blob(); })
            .then((data) => {
                let a = document.createElement("a")
                a.href = window.URL.createObjectURL(data);
                a.download = documentName;
                a.click();
                setDownloadState(false);;
            }).catch((err) => {
   
                setDownloadErrorState(true);
                setDownloadState(false);
                setErrorMessage(err.message)
            })
    }

    if (!documentFileName) {
        return (<React.Fragment></React.Fragment>)
    }

    const downloadDoc = (e) => {
        e.preventDefault();
        downloadDocument(documentId, documentFileName, tokenState.accessToken, document)
    };

    if (downloadingState) {
        return <React.Fragment>
            <Grid item xs={12}>
            <p>{`Downloading ${documentFileName} ...`}</p>         
                <CircularProgress  />
            </Grid>
        </React.Fragment>
    }


    if(downloadErrorState) {
        return (
            <React.Fragment>
                <Grid item xs={12}>
                    <p>{errorMessage}</p>
                    <ErrorOutlineIcon color="error" />
                </Grid>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <p><a onClick={downloadDoc} href="#">{documentFileName}</a></p>
                <FileCopyIcon />
            </Grid>
        </React.Fragment>
    );
};

export default MessageAttachment;
